import { gql } from '@apollo/client'

export const NOTIFICATION_FIELDS = gql`
    fragment NotificationFields on Notification {
        id
        userId
        campaignId
        adCampaignId
        type
        message
        isNew
        createdAt
    }
`

export const GET_NOTIFICATIONS = gql`
    ${NOTIFICATION_FIELDS}
    query GetNotifications($userId: ID!, $limit: Int, $offset: Int, $types: [String!], $unreadOnly: Boolean, $campaignId: ID) {
        getNotifications(
            userId: $userId
            limit: $limit
            offset: $offset
            types: $types
            unreadOnly: $unreadOnly
            campaignId: $campaignId
        ) {
            items {
                ...NotificationFields
            }
            total
            unreadCount
        }
    }
`

export const GET_UNREAD_NOTIFICATIONS_COUNT = gql`
    query GetUnreadNotificationsCount($userId: ID!) {
        getUnreadNotificationsCount(userId: $userId)
    }
`

export const MARK_NOTIFICATIONS_READ = gql`
    mutation MarkNotificationsRead($ids: [ID!]!) {
        markNotificationsRead(ids: $ids)
    }
`

export const MARK_ALL_NOTIFICATIONS_READ = gql`
    mutation MarkAllNotificationsRead($userId: ID!) {
        markAllNotificationsRead(userId: $userId)
    }
`

export const NOTIFICATION_RECEIVED = gql`
    ${NOTIFICATION_FIELDS}
    subscription NotificationReceived($userId: ID!) {
        notificationReceived(userId: $userId) {
            ...NotificationFields
        }
    }
`
